export default function NotAuth(props) {
  return <div>Not Aithorised</div>;
}
